export default async function (to, from, next, store) {
    const user = store.getters['auth/user'];

    if (user.role !== 'customer') {
        next('/chats');
        return false;
    }

    return true;
};
